// 节点类型 
export const ELEMENT_TYPE = 'qablock';
export const MENU_KEY = 'xh_qa_key';
export const MENU_NAME = '问答';
export const MENU_ICON = ''